/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const t=()=>{const t=new WeakSet;return(e,r)=>{if(!e.startsWith("_")){if("object"==typeof r&&null!==r){if(t.has(r))return;t.add(r)}return r}}};export{t as ignoreCircularRefs};
//# sourceMappingURL=ignoreCircularRefs.js.map
